import { faGithub, faInternetExplorer } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Carousel, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { ProjectList } from "../Projects/ProjectList";




function ProjectDisplay() {
    const { id } = useParams();
    const project = ProjectList[id];
    return (
        <div className="container mt-5 mb-5">
            <Row>
                <Col xs={12} md={6}>
                    <Carousel variant="dark card">
                        <Carousel.Item>
                            <img
                                className="d-block w-100 shadow mb-5 rounded"
                                src={project.image1}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 shadow mb-5 rounded"
                                src={project.image2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 shadow mb-5 rounded"
                                src={project.image3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </Col>
                <Col xs={12} md={6}>
                    <div className='text-start mt-5'>
                        <h1 className="fs-1">{project.name}</h1>
                        <h2>{project.shortDes}</h2>
                        <p className='mt-4 mb-4 text-white'> {project.features}</p>
                        <h2>Tools: {project.skills}</h2>


                        <div className="d-flex gap-3 mt-4">
                            <a href={project.gitLink} target="_blank" rel="noreferrer"><Button size="lg" variant="outline-secondary"> Source <FontAwesomeIcon icon={faGithub} color="" /></Button></a>

                            <a href={project.LiveLink} target="_blank" rel="noreferrer">  <Button size="lg" variant="outline-warning">Live Site <FontAwesomeIcon icon={faInternetExplorer} /></Button></a>
                        </div>
                    </div>
                </Col>
            </Row>



        </div >
    );
}

export default ProjectDisplay;